import { useEffect, useState } from "react";
import { loadGuilds } from "../http/fetch-status";
import { WEEK_FROM, WEEK_TO, WEEKS_ARRAY } from "../utils/constants";

const Guilds = () => {
  const [guilds, setGuilds] = useState([]);
  const [sortOn, setSortOn] = useState("kills");

  const [combatType, setCombatType] = useState("RVR");
  const [weekFrom, setWeekFrom] = useState(WEEK_TO);
  const [weekTo, setWeekTo] = useState(WEEK_TO);
  const [timezone, setTimezone] = useState("0-23");
  const [search, setSearch] = useState("");
  const [participation, setParticipation] = useState(0.1);
  const [maxKills, setMaxKills] = useState(0);

  const fetchGuilds = async () => {
    const response = await loadGuilds({
      combatType,
      weekFrom,
      weekTo,
      timezone,
    });
    setGuilds(response.data);
    setMaxKills(response.data[1].kills);
  };

  //console.log(maxKills);

  useEffect(() => {
    fetchGuilds();
  }, [combatType, timezone, weekFrom, weekTo]);

  const guildSort = (a, b) => {
    switch (sortOn) {
      case "kills":
        return b.kills - a.kills;
      case "assists":
        return b.assists - a.assists;
      case "guildassists":
        return b.guild_assists - a.guild_assists;
      case "kills+assists":
        return b.assists + b.kills - (a.assists + a.kills);
      case "damage":
        return b.damage - a.damage;
      case "kills:died":
        return b.kills / b.died - a.kills / a.died;
      case "died":
        return b.died - a.died;
      case "killsassists:died":
        return b.kad - a.kad;
      default:
        return b.kills - a.kills;
    }
  };

  const handleTypeChange = (e) => {
    setCombatType(e.target.value);
  };
  const handleWeekFromChange = (e) => {
    setWeekFrom(e.target.value);
  };

  const handleWeekToChange = (e) => {
    setWeekTo(e.target.value);
  };

  const handleTimezoneChange = (e) => {
    setTimezone(e.target.value);
  };

  const handleParticipationChange = (e) => {
    setParticipation(e.target.value);
  };

  return (
    <div>
      <div className="text-black mt-5 mb-10 grid md:grid-cols-4 lg:grid-cols-4 gap-2 md:gap-10">
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">AREA</label>
          <select onChange={handleTypeChange}>
            <option value="RVR">RvR</option>
            <option value="SCENARIO T4">Scenario</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">FROM</label>
          <select onChange={handleWeekFromChange} value={weekFrom}>
            {WEEKS_ARRAY.map((week) => {
              return (
                <option value={week.value} key={week.value}>
                  {week.label}
                </option>
              );
            })}
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">TO</label>
          <select onChange={handleWeekToChange} value={weekTo}>
            {WEEKS_ARRAY.map((week) => {
              return (
                <option value={week.value} key={week.value}>
                  {week.label}
                </option>
              );
            })}
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">TIMEZONE (utc)</label>
          <select onChange={handleTimezoneChange} value={timezone}>
            <option value="0-23">All</option>
            <option value="0-5">0h-5am</option>
            <option value="6-11">6am-11am</option>
            <option value="12-17">12pm-5pm</option>
            <option value="18-23">6pm-11pm</option>
          </select>
        </div>
      </div>
      <div className="text-black mt-5 mb-10 grid md:grid-cols-4 lg:grid-cols-4 gap-2 md:gap-10">
        <div className="col-span-1 flex flex-col">
          <label className="text-xs text-gray-500">&nbsp;</label>
          <input
            type="text"
            value={search}
            placeholder={`search guild`}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
          ></input>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">Participation</label>
          <select onChange={handleParticipationChange} value={participation}>
            <option value={0}>All</option>
            <option value={0.5}>50%+ Kills</option>
            <option value={0.25}>25%+ Kills</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-7 text-center text-xxs p-2 uppercase">
        <div className={`text-gray-400 text-left`}>Guild</div>
        <div
          className={`cursor-pointer hover:text-gray-200 ${
            sortOn == "kills" ? "text-white font-bold" : "text-gray-400"
          }`}
          onClick={() => setSortOn("kills")}
        >
          KILLS
        </div>
        <div
          className={`cursor-pointer hover:text-gray-200 ${
            sortOn == "assists" ? "text-white font-bold" : "text-gray-400"
          }`}
          onClick={() => setSortOn("assists")}
        >
          assists
        </div>
        <div
          className={`cursor-pointer hover:text-gray-200 ${
            sortOn == "guildassists" ? "text-white font-bold" : "text-gray-400"
          }`}
          onClick={() => setSortOn("guildassists")}
        >
          guild a
        </div>
        <div
          className={`cursor-pointer hover:text-gray-200 ${
            sortOn == "damage" ? "text-white font-bold" : "text-gray-400"
          }`}
          onClick={() => setSortOn("damage")}
        >
          DMG%
        </div>
        <div
          className={`cursor-pointer hover:text-gray-200 ${
            sortOn == "died" ? "text-white font-bold" : "text-gray-400"
          }`}
          onClick={() => setSortOn("died")}
        >
          Deaths
        </div>
        <div
          className={`cursor-pointer hover:text-gray-200 ${
            sortOn == "kills:died" ? "text-white font-bold" : "text-gray-400"
          }`}
          onClick={() => setSortOn("kills:died")}
        >
          KD
        </div>
      </div>
      {guilds
        .filter((g) => g.guild != "-")
        .filter((g) => g.kills >= maxKills * participation)
        .filter((g) => g.assists >= 100)
        .filter((g) => g.guild.toLowerCase().includes(search))
        .sort((a, b) => guildSort(a, b))
        .map((guild) => {
          return (
            <div className="grid grid-cols-7 text-center text-xs p-2">
              <div className="text-left">{guild.guild}</div>
              <div>{guild.kills}</div>
              <div>{guild.assists}</div>
              <div>{guild.guild_assists}</div>
              <div>{guild.damage}</div>
              <div>{guild.died}</div>
              <div>{(guild.kills / guild.died).toFixed(2)}</div>
            </div>
          );
        })}
    </div>
  );
};

export default Guilds;
